import { getConfigValue } from '@/helpers/configHelper';

import axios from 'axios';

const flippyEndpoint = getConfigValue('flippyEndpoint');

export const flippyService = {
  async fetchFeatureFlag(featureFlipName, sessionToken, venueId) {
    const url = `${flippyEndpoint}/features/${featureFlipName}?scope=venue-${venueId}`;
    const response = await axios.get(url, {
      headers: {
        'X-SESSION-TOKEN': sessionToken
      }
    });
    return { [featureFlipName]: response.data };
  }
};

export default flippyService;
